export default "__VITE_ASSET__Q_R3XhDB__"